import router from "../router"
import { removeToken } from "../utils/auth"

export const useReLogin = () => {
  removeToken()
  router.push('/login')
}